<sc-modal #notificationsModal>

  <sc-modal-header>
    <div class="row align-items-center">
      <div class="col-auto me-n2">
        <span class="icon">
          <i class="fa-sharp fa-solid fa-bell"></i>
        </span>
      </div>
      <div class="col">
        <h5 class="modal-title mb-0">{{ texts.title[language] }}</h5>
      </div>
    </div>
  </sc-modal-header>

  <sc-modal-body maxHeight="70vh">

    <p class="text-muted mb-0" *ngIf="items?.length == 0">
      {{ texts.empty[language] }}
    </p>
    <ul class="list-unstyled fw-normal">

      <li *ngFor="let item of items" [ngSwitch]="item.Content" (click)="execute(item);" class="mb-2">

        <app-notifications-modal-item *ngSwitchCase="'#candidatedecide'">
          <div class="row align-items-center">
            <div class="col-auto">
              <sc-avatar class="me-2" size="sm" [user]="item.Candidate"></sc-avatar>
            </div>
            <div class="col col-shrink fw-normal">
              <div class="oneline"><strong>{{ item.Candidate?.FirstName }} {{ item.Candidate?.LastName }}</strong> {{ texts.waitingForResponse[language] }}</div>
              <div class="small oneline">{{ item.Project?.Name | truncate: 45 }} {{ texts.genderSuffix[language] }}</div>
            </div>
          </div>
        </app-notifications-modal-item>

        <app-notifications-modal-item *ngSwitchCase="'#candidatefeedback'">
          <div class="row align-items-center">
            <div class="col-auto">
              <sc-avatar class="me-2" size="sm" [user]="item.Candidate"></sc-avatar>
            </div>
            <div class="col fw-normal">
              <div class="oneline"> {{ texts.yourAssessmentOf[language] }} <strong>{{ item.Candidate?.FirstName }} {{ item.Candidate?.LastName }}</strong></div>
              <div class="small oneline">{{ item.Project?.Name | truncate: 45 }} {{ texts.genderSuffix[language] }}</div>
            </div>
          </div>
        </app-notifications-modal-item>

        <app-notifications-modal-item *ngSwitchCase="'#candidatestatus'">
          <div class="row align-items-center">
            <div class="col-auto">
              <sc-avatar class="me-2" size="sm" [user]="item.Candidate"></sc-avatar>
            </div>
            <div class="col col-shrink fw-normal">
              <div class="oneline">{{ texts.statusOf[language] }} <strong>{{ item.Candidate?.FirstName }} {{ item.Candidate?.LastName }}</strong></div>
              <div class="small oneline">{{ item.Project?.Name | truncate: 45 }} {{ texts.genderSuffix[language] }}</div>
            </div>
          </div>
        </app-notifications-modal-item>

        <app-notifications-modal-item *ngSwitchCase="'#projectreviewjobsite'">
          <div class="row align-items-center">
            <div class="col-auto">
              <sc-avatar class="me-2" size="sm"></sc-avatar>
            </div>
            <div class="col col-shrink fw-normal">
              <div class="oneline">{{ texts.statusOf[language] }} <strong>{{ item.Candidate?.FirstName }} {{ item.Candidate?.LastName }}</strong></div>
              <div class="small oneline">{{ item.Project?.Name | truncate: 45 }} {{ texts.genderSuffix[language] }}</div>
            </div>
          </div>
        </app-notifications-modal-item>

        <app-notifications-modal-item *ngSwitchCase="'#projectfeedbackjobsite'">
          <div class="row align-items-center">
            <div class="col-auto">
              <sc-avatar class="me-2" size="sm"></sc-avatar>
            </div>
            <div class="col col-shrink fw-normal">
              <div class="oneline">{{ texts.statusOf[language] }} <strong>{{ item.Candidate?.FirstName }} {{ item.Candidate?.LastName }}</strong></div>
              <div class="small oneline">{{ item.Project?.Name | truncate: 45 }} {{ texts.genderSuffix[language] }}</div>
            </div>
          </div>
        </app-notifications-modal-item>
      </li>
    </ul>

  </sc-modal-body>
</sc-modal>
